import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const trustSignals = [
    {
      icon: 'Shield',
      title: 'GDPR Compliant',
      description: 'Veilige gegevensverwerking volgens Europese standaarden'
    },
    {
      icon: 'Award',
      title: 'KvK Geregistreerd',
      description: 'Officieel geregistreerd bij de Kamer van Koophandel'
    },
    {
      icon: 'Lock',
      title: 'SSL Beveiligd',
      description: 'Alle gegevens worden versleuteld verzonden'
    },
    {
      icon: 'CheckCircle',
      title: 'RVO Erkend',
      description: 'Erkend door Rijksdienst voor Ondernemend Nederland'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-6">
      <div className="text-center mb-6">
        <Icon name="Shield" size={32} color="var(--color-success)" className="mx-auto mb-3" />
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Veilig & Betrouwbaar
        </h3>
        <p className="text-sm font-body text-muted-foreground">
          Uw gegevens zijn veilig bij ons
        </p>
      </div>
      <div className="space-y-4">
        {trustSignals?.map((signal, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name={signal?.icon} size={16} color="var(--color-success)" />
              </div>
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                {signal?.title}
              </h4>
              <p className="text-xs font-body text-muted-foreground">
                {signal?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-center space-x-4">
          <div className="flex items-center space-x-1">
            <Icon name="Users" size={14} color="var(--color-primary)" />
            <span className="text-xs font-caption text-muted-foreground">2.500+ Providers</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Star" size={14} color="var(--color-accent)" />
            <span className="text-xs font-caption text-muted-foreground">4.8/5 Rating</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;